export const FRIDAY_TEMPLATE_KEYS = ["fridays", "fridays2025"];

export const RAMADAN_FULL_MONTH_TEMPLATE_KEYS = [
  "ramadan_lunar_2026",
  "ramadan_hijri_2026",
  "ramadan_zakat_lunar_2026",
  "ramadan_zakat_hijri_2026",
  "ramadanlunar",
  "ramadanhijri"
];

export const RAMADAN_TEN_NIGHT_TEMPLATE_KEYS = [
  "hijri10",
  "lunar10",
  "ramadanlunar10",
  "ramadanhijri10"
];

export const RAMADAN_TEMPLATE_KEYS = [
  ...RAMADAN_FULL_MONTH_TEMPLATE_KEYS,
  ...RAMADAN_TEN_NIGHT_TEMPLATE_KEYS
];

export const DHUL_HIJJAH_TEMPLATE_ALIASES = {
  hijri: "dhul_hijjah_hijri_2026",
  lunar: "dhul_hijjah_lunar_2026"
};

export const DHUL_HIJJAH_TEMPLATE_KEYS = [
  "dhul_hijjah_hijri_2026",
  "dhul_hijjah_lunar_2026",
  ...Object.keys(DHUL_HIJJAH_TEMPLATE_ALIASES)
];

export const DHUL_HIJJAH_2026_START_DATE = "2026-05-18";
export const DHUL_HIJJAH_2026_END_DATE = "2026-05-27";
export const DHUL_HIJJAH_2026_ARAFAH_DATE = "2026-05-26";
export const DHUL_HIJJAH_2026_EID_DATE = "2026-05-27";

export const normalizeTemplate = (template) =>
  String(template || "").trim().toLowerCase();

export const isFridayTemplateKey = (templateKey) =>
  FRIDAY_TEMPLATE_KEYS.includes(normalizeTemplate(templateKey));

export const isZakatTemplateKey = (templateKey) =>
  normalizeTemplate(templateKey).includes("zakat");

export const isRamadanTemplateKey = (templateKey) =>
  RAMADAN_TEMPLATE_KEYS.includes(normalizeTemplate(templateKey));

export const isRamadanTenNightTemplateKey = (templateKey) =>
  RAMADAN_TEN_NIGHT_TEMPLATE_KEYS.includes(normalizeTemplate(templateKey));

export const isDhulHijjahTemplateKey = (templateKey) =>
  DHUL_HIJJAH_TEMPLATE_KEYS.includes(normalizeTemplate(templateKey));

export const getCanonicalTemplateKey = (templateKey) => {
  const normalized = normalizeTemplate(templateKey);
  return DHUL_HIJJAH_TEMPLATE_ALIASES[normalized] || normalized;
};

export const getTemplateDisplayName = (template) => {
  const normalized = normalizeTemplate(template);

  if (normalized === "dhul_hijjah_hijri_2026") {
    return "Dhul Hijjah Hijri 2026";
  }

  if (normalized === "dhul_hijjah_lunar_2026") {
    return "Dhul Hijjah Lunar 2026";
  }

  if (normalized === "ramadan_hijri_2026") {
    return "Ramadan Hijri 2026";
  }

  if (normalized === "ramadan_lunar_2026") {
    return "Ramadan Lunar 2026";
  }

  if (normalized === "ramadan_zakat_hijri_2026") {
    return "Ramadan Zakat Hijri 2026";
  }

  if (normalized === "ramadan_zakat_lunar_2026") {
    return "Ramadan Zakat Lunar 2026";
  }

  if (isFridayTemplateKey(normalized)) {
    return "Fridays";
  }

  return template || "Calendar";
};
